class HistoryRecord{
    constructor(){
        //最多保留100条对话（一个对话算两条） 实际并不一定会是100 因为机器人返回消息可能是多条的组合
        this.maxNum = 200;
        this.oldHistory = JSON.parse(localStorage.getItem('chatbotzp-historyredocd')) || [];
        console.log(this.oldHistory );
        this.newHistory = this.oldHistory;
        this.index = 0;
        this.numPerGet = 200;
    }

    addHistoryRecord(msg =[]){
        let msgByFiltered = msg.filter((item)=>{
             //type -1 异常提示语 -4 跳转 目前不加到history中
            if(item.type===undefined ||  item.type === -4){
                return false;
            }else{
                return true;
            }
        })
        if((this.newHistory.length+msgByFiltered.length)<=this.maxNum){
            //直接插入
            this.newHistory = this.newHistory.concat(msgByFiltered);
        }else{
            let dif = this.newHistory.length+msgByFiltered.length-this.maxNum;
            this.newHistory = this.newHistory.slice(dif);
            this.newHistory = this.newHistory.concat(msgByFiltered);
        }
        localStorage.setItem('chatbotzp-historyredocd',JSON.stringify(this.newHistory))
    }
    getHistoryRecord(){
        let maxIndex = Math.ceil(this.maxNum/this.numPerGet);
        if(this.index > maxIndex-1){
            //取光了
            return [];
        }else{
            let result = this.oldHistory.slice(this.index*this.numPerGet,(this.index+1)*this.numPerGet);
            this.index++;
            console.log(result)
            return result;
        }
    }
}

export default new HistoryRecord();